// extracted by mini-css-extract-plugin
export default {"link":"AuthNav_link__9ReBA"};